"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleSwitch = SimpleSwitch;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function SimpleSwitch(props) {
  var _a, _b, _c;
  var handleChange = function handleChange(name) {
    return function (event, checked) {
      props.onChanged(name, checked);
    };
  };
  return /*#__PURE__*/_react["default"].createElement(_material.FormGroup, {
    row: true
  }, /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
    label: props.label,
    labelPlacement: (_a = props.placement) !== null && _a !== void 0 ? _a : 'start',
    control: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.checkbox && (/*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
      checked: props.checked,
      onChange: handleChange(props.value),
      value: props.value,
      color: (_b = props.color) !== null && _b !== void 0 ? _b : 'primary',
      disabled: props.disabled
    })), !props.checkbox && (/*#__PURE__*/_react["default"].createElement(_material.Switch, {
      checked: props.checked,
      onChange: handleChange(props.value),
      value: props.value,
      color: (_c = props.color) !== null && _c !== void 0 ? _c : 'primary',
      disabled: props.disabled
    })))
  }));
}